import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userManager } from "../auth-config";
import { takePostLoginRedirect } from "../authRedirect";

export const CallbackPage = () => {
	const navigate = useNavigate();

	useEffect(() => {
		(async () => {
			try {
				await userManager.signinRedirectCallback();
				navigate(takePostLoginRedirect("/"), { replace: true });
			} catch (error) {
				console.error("Sign-in callback error:", error);
				navigate("/login", { replace: true });
			}
		})();
	}, [navigate]);

	return (
		<div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-app)]">
			<div className="text-center">
				<div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent)] border-t-transparent mx-auto" />
				<p className="mt-4 text-[var(--color-text-secondary)]">
					Completing login...
				</p>
			</div>
		</div>
	);
};
